import { render, staticRenderFns } from "./SelectorTodos_Sim_Nao.vue?vue&type=template&id=d2d565d0"
import script from "./SelectorTodos_Sim_Nao.vue?vue&type=script&lang=js"
export * from "./SelectorTodos_Sim_Nao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports